<footer class="footer container">
    <div class="row footer-main">
        <div class="col-12 d-flex justify-content-between pl-0">
            <div class="info-container">
                Educere LLC <br>
                455 Pennsylvania Avenue, Suite 140 <br>
                Fort Washington PA, 19034 <br>
                <a href="https://www.educere.net" target="_blank">educere.net</a> <br>
                <a href="mailto:educere@educere.net">educere&#64;educere.net</a> * 866.4EDUCERE (866.433.8237)
            </div>
            
            <div class="logo-container">
                <img src="assets/logos/educere_209x90.jpg" alt="">
            </div>        
        </div>
    </div>
</footer>
